export default (editor, $vue) => {
  // Add any button like so
  // const editorPanels = editor.Panels;
  // editorPanels.addButton('options', {
  //   id: 'id',
  //   el: loadHtmltemplate,
  //   className: 'fa fa-bell',
  //   command: (e) => e.runCommand('your-command'),
  // });

  editor.Panels.addButton('views', {
    id: 'Clear',
    className: 'fa fa-eraser',
    visible: true,
    command: editor => {
      if (window.confirm('You lose all changes made so far.')) {
        editor.Commands.run('core:canvas-clear')
        editor.setComponents(`<mjml><mj-body><mj-section></mj-section></mj-body></mjml>'`)
      }
    },
    attributes: {
      title: $vue.$t('templates.grapes.panels-views.buttons.clear'),
    },
  })

  editor.Panels.addButton('options', {
    id: 'Save',
    el: `<span title="save" data-tooltip-pos="bottom" class="gjs-pn-btn font-sm">${$vue.$t('templates.grapes.panels-options.buttons.save')}</span>`,
    className: 'btn_panel btn_panel-save px-3 py-2 font-md',
    command: (editor, sender) => {
      sender && sender.set('active', 0) // turn off the button
      editor.Commands.run('save-template')
      editor.Panels.render()
    },
    attributes: {
      title: $vue.$t('templates.grapes.panels-options.buttons.save'),
    },
  })

  editor.Panels.addButton('options', {
    id: 'Discard',
    el: `<span title="save" data-tooltip-pos="bottom" class="gjs-pn-btn font-sm">${$vue.$t(
      'templates.grapes.panels-options.buttons.discard',
    )}</span>`,
    className: 'btn_panel mx-2 px-3 py-2 font-md',
    visible: true,
    command: editor => {
      if (window.confirm($vue.$t('templates.grapes.panels-options.popup.discard'))) {
        editor.Commands.run('delete-template')
      }
    },
    attributes: {
      title: $vue.$t('templates.grapes.panels-options.buttons.discard'),
    },
  })

  // TODO ideal seria deixar aqui. n consegui fazer funcionar, talvez seja o evento errado..
  // editor.on('component:mount', a => {
  //   editor.Panels.getButton('views', 'open-blocks').set('active', true)
  //   editor.Panels.getButton('options', 'redo').set('className', 'fa fa-redo')

  //   const exportTemplate = this.editor.Panels.getButton('options', 'export-template')
  //   const mjmlImport = this.editor.Panels.getButton('options', 'mjml-import')
  //   const layer = this.editor.Panels.getButton('views', 'open-layers')
  //   exportTemplate.collection.remove(exportTemplate)
  //   mjmlImport.collection.remove(mjmlImport)
  //   layer.collection.remove(layer)
  // })
}
